import { UserBasedItemRestraints } from '../user-item.restraints';
import { roleCheck, UserRole } from '@core/shared/access';
export class UserRestraints extends UserBasedItemRestraints {
  userEditsSelf(item) {
    if (!item.id) return false; // cannot error here because it may be a new entity without existing ID
    const userId = this.access.getAccessData('userId', null, 'throw');
    return this.access.isLoggedIn ? item.id === userId : false;
  }
  canUserSetRole(item) {
    const isAdmin = this.hasRole('ADMINISTRATOR');
    if (this.access.isSU) {
      return true;
    } else if (isAdmin) {
      if (roleCheck(UserRole.SUPERUSER, item.userRole)) return 'Superuser können nur von Superusern erstellt werden.';
      return true;
    } else {
      if (roleCheck(UserRole.ADMINISTRATOR, item.userRole)) return 'Superuser/Admins können nur von Superusern/Admins erstellt werden.';
      return true;
    }
  }
  canCreateItem(item) {
    // system will create item when a new account shall be registered
    if (this.isExecutedBySystem()) return true;
    const isAdmin = this.hasRole('ADMINISTRATOR');
    if (isAdmin) {
      return this.canUserSetRole(item);
    }
    ;
    if (this.currentUserManagesCompany(item)) {
      return this.canUserSetRole(item);
    } else {
      return 'Sie können nur User für Ihr Unternehmen erstellen.';
    }
  }
  canToggleItem(item) {
    // return this.requireRole('REGISTERED',()=>{
    if (this.userEditsSelf(item)) {
      return 'Sie können Ihren eigenen Account nicht deaktivieren.';
    } else if (this.access.isAdmin) {
      if (item.id <= 2) {
        return 'Dieser Nutzer darf nicht deaktiviert werden.';
      }
      return true;
    } else {
      return 'Sie dürfen den Status dieses Nutzers nicht verändern.';
    }
    // })
  }
  canUpdateItem(item, oldItem) {
    // ensure updating in general is allowed
    if (this.isExecutedBySystem()) return true;
    const isAdmin = this.hasRole('ADMINISTRATOR');
    if (!isAdmin && !this.currentUserManagesCompany(item) && !this.userEditsSelf(item)) {
      return 'Sie haben keine Erlaubnis, diesen User zu bearbeiten.';
    }
    // from here on, we can assume editing user is either admin, edits own data, or manages company of the user.
    // ensure toggling is allowed
    const setsEnabledState = typeof item.enabled === 'boolean';
    if (oldItem && setsEnabledState && item.enabled !== oldItem.enabled) {
      const canToggle = this.canToggleItem(item);
      if (canToggle !== true) return canToggle;
    }
    // ensure setting userRole is allowed
    if (typeof item.userRole !== 'undefined') {
      if (item.id <= 2 && item.userRole !== UserRole.SUPERUSER) {
        return 'Die Superuser-Rolle dieses Users kann nicht entfernt werden.';
      }
      const tmp = this.canUserSetRole(item);
      if (tmp !== true) return tmp;
      if (this.userEditsSelf(item)) {
        if (oldItem && oldItem.userRole !== item.userRole) {
          return 'Sie können die Rolle ihres Accounst nicht selbst verändern';
        }
        // in case oldItem is not available for some reason, we do an additional check to ensure SU/Admin accounts don't loose role by accident.
        if (this.access.isSU) {
          if (item.userRole !== UserRole.SUPERUSER) return 'Sie können die Rolle ihres Accounst nicht selbst verändern';
        } else if (isAdmin) {
          if (item.userRole !== UserRole.ADMINISTRATOR) return 'Sie können die Rolle ihres Accounst nicht selbst verändern';
        }
      }
    }
    return true;
  }
  canRemoveItem(item) {
    const isAdmin = this.hasRole('ADMINISTRATOR');
    const isManager = this.access.simpleAbilityCheck('Programmatic.common-users.IsCompanyManager');
    if (!isAdmin && !isManager) return 'Sie können keine Nutzer entfernen.';
    if (item.id <= 2) return 'Dieser Nutzer darf nicht entfernt werden.';
    if (this.userEditsSelf(item)) return 'Sie können Ihren eigenen Account nicht löschen.';
    if (isAdmin) {
      if (item.userRole === UserRole.SUPERUSER && !this.access.isSU) return 'Superuser können nur von Superusern gelöscht werden.';
      return true;
    }
    ;
    if (item.userRole === UserRole.MANAGER) {
      // TODO: Implement manager deletion
      return 'Manager können momentan noch nicht gelöscht werden.';
    }
    if (isManager) {
      if (item.userRole !== UserRole.REGISTERED) return 'Sie dürfen nur normale User entfernen. (Benutzerrolle ist ' + item.userRole + ')';
      if (!this.currentUserManagesCompany(item)) return 'Sie dürfen nur Mitglieder Ihres eigenen Teams entfernen.';
      return true;
    }
  }
  currentUserManagesCompany(item) {
    if (!this.hasRole('MANAGER')) return false;
    const companyId = item.companyId || item.company?.id;
    if (!companyId) throw new Error('currentUserManagesCompany failed: User has no info on managed company available.');
    const managedCompany = this.access.getAccessData('managedCompany', null, 'null');
    if (!managedCompany) return false;
    return companyId === managedCompany.id;
  }
}